import { useEffect, useState } from 'react';

import { ApplicationSuite,AppSuiteTenant } from 'common/types/Entities';

export const useProcessGenerateReportButtonState = (appSuite: ApplicationSuite | null, tenant: AppSuiteTenant | null) => {
    const [disableGenerateButton, setDisableGenerateButton] = useState<boolean>(true);

    useEffect(() => {
        if(tenant && appSuite) {
            setDisableGenerateButton(false);
        } else {
            setDisableGenerateButton(true);
        }
    }, [tenant?.id, appSuite?.id]);

    return { disableGenerateButton };
};
